import CONFIG from "@/config";
import NetUtils from "@/resources/utils/net-utils";
import qs from "qs";

const commonUtils = {
  /**
   * 设置文档标题
   * @param title     @标题名
   */
  setTitle(title) {
    title = title || CONFIG.COMPANY_NAME;
    window.document.title = title;
  },

  /**
   * 网络请求-Get请求
   * @param {*} options      { options.url: 请求地址, options.successFunc: 请求成功回调函数, options.method: 请求方式 }
   */
  GetRequest(options) {
    const opts = Object.assign(
      {
        successFunc(res) {},
        failFunc(err) {}
      },
      options
    );

    NetUtils.ajaxRequest(
      opts,
      res => {
        opts.successFunc(res);
      },
      err => {
        opts.failFunc(err);
      }
    );
  },

  /**
   * 网络请求-Post请求
   * @param {*} options      { options.url: 请求地址, options.successFunc: 请求成功回调函数, options.method: 请求方式 }
   */
  PostRequest(options, isHasNull = false) {
    const opts = Object.assign(
      {
        successFunc(res) {},
        failFunc(err) {},
        method: "POST"
      },
      options
    );

    if (!opts.isUpload) {
      if (!isHasNull) {
        opts.data = qs.stringify(opts.data);
      }
    }

    NetUtils.ajaxRequest(
      opts,
      res => {
        opts.successFunc(res);
      },
      err => {
        opts.failFunc(err);
      },
      isHasNull
    );
  },

  /**
   * 注销登录
   * @param vm
   */
  logoff(vm) {
    vm.$store.commit("logout", {
      successFunc(res) {
        localStorage.removeItem("userInfo");
        vm.$router.push("/login");
      }
    });
  },

  judgePermission(permissionName) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (userInfo) {
      if (userInfo.permissions.indexOf(permissionName) !== -1) {
        return true;
      }
      return false;
    }
  },

  judgePermissionCount(permissionArray) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));

    let permissionCount = 0;

    permissionArray.forEach(permissionItem => {
      const isExistPermission = userInfo.permissions.indexOf(permissionItem);

      if (isExistPermission !== -1) {
        permissionCount++;
      }
    });

    return permissionCount;
  },

  getDateByTimestamp(timestamp) {
    const curDate = new Date(timestamp);

    const curDateObj = {
      year: curDate.getFullYear(),
      month: curDate.getMonth() + 1,
      day: curDate.getDate()
    };

    return curDateObj;
  },

  judgeIsDigits(data) {
    typeof data === "string" ? (data = parseInt(data)) : "";

    if (data < 10) {
      data = "0" + data;
    }

    return data;
  }
};

export const strToTimestamp = timeStr => {
  return Math.floor(new Date(timeStr).getTime() / 1000);
};

export function throttle(handler, time) {
  let can = true;
  return function(value) {
    if (can) {
      can = false;
      handler(value);
      setTimeout(() => {
        can = true;
      }, time);
    }
  };
}

/**
 * @description: js触发下载文件
 */
export function downLoadFile(url) {
  const iframe = document.createElement("iframe");
  iframe.src = url;
  iframe.style.display = "none";
  document.body.appendChild(iframe);
}

/**
 * @description: 深拷贝
 */
export function deepCopy(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  let target = obj instanceof Array ? [] : {};
  for (let key in obj) {
    if (typeof obj[key] === "array") {
      target[key] = obj[key];
    } else {
      target[key] = deepCopy(obj[key]);
    }
  }
  return target;
}

export function timestampParse(timestamp = Date.now(), separator='') {
  let time = new Date(timestamp);
  let y = time.getFullYear();
  let m = time.getMonth() + 1;
  let d = time.getDate();
  let h = time.getHours();
  let mm = time.getMinutes();
  let s = time.getSeconds();

  m = `${m}`.padStart(2, 0);
  d = `${d}`.padStart(2, 0);
  h = `${h}`.padStart(2, 0);
  mm = `${mm}`.padStart(2, 0);
  s = `${s}`.padStart(2, 0);

  return {
    y,
    m,
    d,
    h,
    mm,
    s,
    ymd_str: `${y}${separator}${m}${separator}${d}`
  };
}

export function getUniqueValue() {
  return Math.random()
    .toString(32)
    .slice(2);
}


export  function getDeepObjValue (o, path) {
  try {
    let result = path.split('.').reduce((o, k) => {
      return o[k]
    }, o)
    return result
  } catch (e) {
    return null
  }
}

export function createObjectURL(object) {
  return (window.URL) ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object)
}

export const downLoadFileFn = (url, data = null, filename, method = 'get') => {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest()
    xhr.open(method, url)
    // authorizationField && xhr.setRequestHeader(authorizationField, store.state.userInfo.token)
    // agentField && xhr.setRequestHeader(agentField, store.state.userInfo.agent_token)
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.responseType = 'blob'
    xhr.onload = function (e) {
      if (this.status === 200) {
        let blob = this.response
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, filename)
        } else {
          let a = document.createElement('a')
          let url = createObjectURL(blob)
          a.href = url
          a.download = filename
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        }
        resolve(this.response)
      } else {
        reject(e)
      }
    }
    xhr.onerror = function(e) {
      reject(e)
    }
    xhr.send(data)
  })
}
/**
 * 防抖函数 flag为true 立即执行
 * @param event
 * @param time
 * @param flag
 * @returns {Function}
 */
export const debounce = (event, time, flag) => {
  let timer = null
  return function (...args) {
    clearTimeout(timer)
    if (flag && !timer) {
      event.apply(this, args)
    }
    timer = setTimeout(() => {
      event.apply(this, args)
    }, time)
  }
}
export default commonUtils;



// WEBPACK FOOTER //
// ./src/resources/utils/common-utils.js